<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler">
            <el-form-item label="招标项目名称" v-if="!isZc">
                {{form.zbproname}}
            </el-form-item>
            <el-form-item label="标段（包）名称">
                {{form.bdname}}
            </el-form-item>
            <el-form-item label="标段（包）内容" class="table-full-row">
                <span v-html="form.bdcontent"></span>
            </el-form-item>
             <el-form-item label="住建标段（包）分类代码" v-if="model.hdzj" class="table-full-row">
                {{form.hdzjbdtypecode}}-{{form.hdzjbdtypename}}
            </el-form-item>
            <el-form-item label="标段（包）分类代码">
                {{form.bdtypecode}}-{{form.bdtypename}}
            </el-form-item>
            <el-form-item label="标段（包）投资概算">
                {{form.bdhtgsj}}{{form.jedwname}}{{form.bztext}}
            </el-form-item>
            <el-form-item label="招标文件售价(元)" v-if="!isZc">
                {{form.extzbwjsj}}
            </el-form-item>
            <el-form-item label="图纸押金(元)" v-if="!isZc">
                {{form.exttzyj}}
            </el-form-item>
            <el-form-item label="标书款支付方式" v-if="form.extzbwjsj!='0'&&!isZc">
                {{form.extzbwjzffs}}
            </el-form-item>
            <el-form-item label="投标人资格条件" :class="{'table-full-row': form.extzbwjsj==0}">
                <span v-html="form.tbrzgtj"></span>
            </el-form-item>
            <el-form-item label="缴费说明（投标人缴纳标书款时可见）" v-if="!isZc">
                <span v-if="form.extjfsm==null||form.extjfsm==''||form.extjfsm=='undefined'">无</span>
                <span v-if="form.extjfsm!=null&&form.extjfsm!=''&&form.extjfsm!='undefined'">
                    {{form.extjfsm}}
                </span>
            </el-form-item>
            <el-form-item label="投标保证金(元)" v-if="model.hdzj&&!isZc">
                {{form.exttbbzj}}
            </el-form-item>
            <el-form-item label="是否评定分离" v-if="model.hdzj&&!isZc">
                    <span v-if="form.extstr1=='1'">是</span>
                    <span v-if="form.extstr1=='0'">否</span>
            </el-form-item>
            

            <el-form-item
            v-if="model.datalist && model.datalist.length&&!isZc"
            label="报名资料"
            class="table-full-row"
            prop="tbrzgtj">
                <bm-file
                readonly
                v-model="model.datalist"
                :bmzlguid="form.bmzlguid"></bm-file>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">关闭</el-button>
            </template>
        </my-form>

    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import BmFile from './components/bm-file'

export default {
    mixins: [FORM_PAGE_MIXIN],
    components: { BmFile},

    data: () => ({
        form: {},
        model:{},
        isZc:false,//是否是政采项目
    }),
    methods: {
        
        
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/revision/FangAn/BiaoDuan/detail.json`,{
            id:this.getQuery('id')
        }, data => {
            this.model = data
            this.form = data.model
        });
    },
    mounted() {
        if(this.getQuery('isZc')==='false'){
            this.isZc = false
        }else{
            this.isZc = true
        }
    },
}
</script>

<style scoped lang="scss">

</style>
